import {Step} from "./step";
import {Picture, PictureType} from "./picture";

export class TyrePicture extends Picture {
    step: Step;
    cbdValid?: boolean;

    constructor(step: Step) {
      super(step.toString(), PictureType.TYRE);
      this.step = step;
    }
}
